import ItemCard from '../components/items/cards/ItemCard.js';
import ItemRecord from '../components/items/records/ItemRecord.js';

export default {
    //cards
    'person' : ItemCard,
    'institution' : ItemCard,
    'journal' : ItemCard,
    'journal-number' : ItemCard,
    'work' : ItemCard,
    'publishing-series' : ItemCard,
    'event-series' : ItemCard,
    'event' : ItemCard,
    'series' : ItemCard,
    'creative-work' : ItemCard,
    'place' : ItemCard,
    //records
    'journal-item' : ItemRecord,
    'movie' : ItemRecord,
    'book' : ItemRecord,
    'spectacle' : ItemRecord,
    'radio' : ItemRecord,
    'television' : ItemRecord,
    'letters' : ItemRecord,
    'anthology' : ItemRecord,
    'collective-book' : ItemRecord,
    'authors-book' : ItemRecord,
    'content' : ItemRecord,
};



// WEBPACK FOOTER //
// ./src/scripts/ItemsTypes.js